import { minutesToMs } from '@mi-front/core';
import { ButtonGroup } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { useStationTimeMoveRange } from '../../../../hooks/navigation/useStationTimeMoveRange';
import { useStreamUserDefinedRange } from '../../../../stores/stream-screen.store';
import { TimeMoveButton } from './TimeMoveButton';

const timeMoveForward15mMessage = defineMessage({
  id: 'logger.streamScreen.controls.timeMove.forward15m',
  defaultMessage: '+15m',
});
const timeMoveForward1hMessage = defineMessage({
  id: 'logger.streamScreen.controls.timeMove.forward1h',
  defaultMessage: '+1h',
});

/**
 * Moves the stream forward using MUI ButtonGroup.
 * Renders two grouped buttons: +15m and +1h. Each button is enabled when
 * the new window end would not go past the allowed range end (allowed.to, i.e. now - 20 min).
 */
export function TimeMoveForwardsControl({ isDisabled = false }: { isDisabled?: boolean }) {
  const { $t } = useIntl();
  const range = useStreamUserDefinedRange();
  const allowed = useStationTimeMoveRange();

  const canMoveForward = (minutes: number) => range.from + minutesToMs(minutes) <= allowed.to;

  return (
    <ButtonGroup variant="outlined" color="secondary">
      <TimeMoveButton
        label={$t(timeMoveForward15mMessage)}
        minutes={15}
        disabled={!canMoveForward(15) || isDisabled}
      />
      <TimeMoveButton
        label={$t(timeMoveForward1hMessage)}
        minutes={60}
        disabled={!canMoveForward(60) || isDisabled}
      />
    </ButtonGroup>
  );
}
